import { inject, provide } from 'vue'
import type { PrivateBoxEntry } from '@deepcloud/api-deep-box'
import type { InjectionKey } from 'vue'

type InjectionData =
  Ref<PrivateBoxEntry | undefined> | ComputedRef<PrivateBoxEntry | undefined>

const KEY = Symbol('ContextBoxPrivate') as InjectionKey<InjectionData>

export function createContextBoxPrivate(injectionData: InjectionData) {
  provide(KEY, injectionData)
}

export function useContextBoxPrivate() {
  const injectionData = inject(KEY)
  if (!injectionData) {
    throw new Error(
      'Please call `createContextBoxPrivate` on the appropriate parent component',
    )
  }

  return injectionData
}
